import React, { useState, useEffect } from "react";
import "./NewMember.css";
import { Link } from "react-router-dom";

import Input from "../UI/input/input";
import * as Moment from "moment";
import Menu from "../menu/menu";
import styled from "styled-components";

import { iMemberProfile } from "../UI/MemberProfileInterface";

const NewMember = (props) => {
  const [state, setState] = useState({
    memberFormWasPopulated: false,
    welcome: [
      "Hvis du har spørgsmål eller lign. kan du skrive til os i kommentar feltet, eller skrive en email til skovbokarate@gmail.com. Du kan også ringe til Mugo Petersen på 31667121.",
      "Vi tilbyder gratis træning den første måned.",
      "- Udfyld nedenstående og tryk på 'send Indmelding'",
    ],
    newMember: { ...iMemberProfile },
    memberForm: {
      FirstName: {
        label: "Fornavn",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Fornavn",
          required: true,
        },
        value: "",
      },
      LastName: {
        label: "Efternavn",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Efternavn",
          required: true,
        },
        value: "",
      },

      Address: {
        label: "Adresse",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Adresse",
          required: true,
        },
        value: "",
      },
      Postno: {
        label: "Post nummer",
        elementType: "input",
        elementConfig: {
          required: true,
          type: "text",
          placeholder: "Post nummer",
        },
        value: "",
      },
      City: {
        label: "By",
        elementType: "input",
        elementConfig: {
          required: true,
          type: "text",
          placeholder: "By",
        },
        value: "",
      },
      Birthdate: {
        label: "Fødselsdag",
        elementType: "input",
        elementConfig: {
          required: true,
          type: "date",
          placeholder: "Fødselsdag",
        },
        value: "",
      },
      Phone: {
        label: "Telefon",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Telefon",
        },
        value: "",
      },
      Email: {
        label: "Email",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Email",
        },
        value: "",
      },
      PaymentEmail: {
        label: "Email til kontingentopkrævning",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "kontingentopkrævnings Email",
          required: true,
        },
        value: "",
      },
      TeamName: {
        label: "Karate hold",
        elementType: "select",
        elementConfig: {
          options: [],
          placeholder: "Hold",
        },
        value: "",
      },
      Started: {
        label: "Startet",
        elementType: "input",
        elementConfig: {
          type: "date",
          placeholder: "Startet",
        },
        value: "",
      },
      Parent: {
        label: "Forældre/værge (hvis du er under 18 år)",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Forældre",
        },
        value: "",
      },
      ParentPhone: {
        label: "Forældre Telefon",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Forældre Telefon",
        },
        value: "",
      },
      ParentEmail: {
        label: "Forældre Email",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Forældre Email",
        },
        value: "",
      },
      Comment: {
        label: "Evt. Kommentar",
        elementType: "input",
        elementConfig: {
          type: "text",
          placeholder: "Kommentar",
        },
        value: "",
      },
    },
  });

  useEffect(() => {
    // Check if members data has been loaded if not then load members data.
    // && !state.memberFormWasPopulated
    if (props.firebaseReady && !props.teams) {
      console.log("load teams:", props.teams);
      props.loadTeams();
    }

    // has teams been populated yet?
    if (props.teams && !state.memberFormWasPopulated) {
      console.log("Populate form with teams:", props.teams);
      populateFormFromProps();
    }
  }, [state.memberFormWasPopulated, props]);

  const populateFormFromProps = () => {
    // add data to form if props is present
    const memberForm = { ...state.memberForm };
    let memberFormElement = {};

    for (let key in memberForm) {
      // add teams to form element selector
      if (key == "TeamName") {
        // set current memeber team
        memberFormElement = { ...memberForm[key] };
        memberFormElement.value = state.newMember.TeamId;

        let memberFormElementOptions = { ...memberFormElement.elementConfig };
        for (let key in props.teams) {

          const x = props.teams[key].ID
          if (x == 0 || x == 1 || x == 999)
          memberFormElementOptions.options.push({
            value: props.teams[key].ID,
            title: props.teams[key].TeamName,
          });
        }
        memberFormElement.options = { ...memberFormElementOptions };

        memberForm[key] = memberFormElement;
      }

      if (key == "Started") {
        memberFormElement = { ...memberForm[key] };
        memberFormElement.value = Moment().toString();
        memberForm[key] = memberFormElement;
      }
    }

    setState({ ...state, memberForm, memberFormWasPopulated: true });
  };

  const inputChanged = (event, elementKey) => {
    const updatedMemberForm = { ...state.memberForm };
    const updatedFormElement = { ...updatedMemberForm[elementKey] };
    updatedFormElement.value = event.target.value;
    updatedMemberForm[elementKey] = updatedFormElement;

    setState({ ...state, memberForm: { ...updatedMemberForm } });
    // console.log("memberform:", state.memberForm);
  };

  const formElementArry = [];
  for (let key in state.memberForm) {
    formElementArry.push({
      id: key,
      config: state.memberForm[key],
    });
  }

  const welcome = state.welcome.map((w, idx) => <p key={idx}>{w}</p>);

  const form = (
    <form
      onSubmit={(e) => {
        e.preventDefault();

        // console.log("Event: ", e);
        // console.log("memberForm: ", state.memberForm);

        const newmember = {
          FirstName: state.memberForm.FirstName.value,
          LastName: state.memberForm.LastName.value,
          // Title : state.memberForm.Title.value,
          TeamName: state.memberForm.TeamName.label,
          TeamId: state.memberForm.TeamName.value,
          // Role : state.memberForm.Role.value,
          // ExtraRole : state.memberForm.ExtraRole.value,
          Postno: state.memberForm.Postno.value,
          Address: state.memberForm.Address.value,
          City: state.memberForm.City.value,
          Phone: state.memberForm.Phone.value,
          Email: state.memberForm.Email.value,
          Birthdate: state.memberForm.Birthdate.value,
          Parent:
            state.memberForm.Parent.value && state.memberForm.Parent.value,
          ParentPhone:
            state.memberForm.ParentPhone.value &&
            state.memberForm.ParentPhone.value,
          ParentEmail:
            state.memberForm.ParentEmail.value &&
            state.memberForm.ParentEmail.value,
          PaymentEmail:
            state.memberForm.PaymentEmail.value &&
            state.memberForm.PaymentEmail.value,
          Started: state.memberForm.Started.value,
          // Stopped : state.memberForm.Stopped.value,
          Comment: state.memberForm.Comment.value,
          // ImageUrl : state.memberForm.ImageUrl.value
          Status: iMemberProfile.Status,
        };

        props.addNewMember(e, newmember);
      }}
    >
      {formElementArry.map((formElement) => (
        <Input
          key={formElement.id}
          label={formElement.config.label}
          elementType={formElement.config.elementType}
          elementConfig={formElement.config.elementConfig}
          value={formElement.config.value}
          changed={(e) => inputChanged(e, formElement.id)}
        />
      ))}
      <input className="input-submit" type="submit" value="Send Indmeldelse" />
    </form>
  );

  return (
    <div className="new-member">
      {/* <Menu color="white" currentlyLoggedInUser={props.currentlyLoggedInUser} /> */}
      <div className="header-wrapper">
        <div className="header-top">
          <img src="/icons/apple-icon-72x72.png" />
          <div className="header-title">
            <h3>Indmeldelse i Skovbo Karate Klub</h3>
          </div>
        </div>
        <div className="welcome">
          {welcome}
          
        </div>
      </div>

      <div className="main-content-wrapper">
        <div className="member-id">{state.newMember.ID}</div>
        {form}
      </div>
    </div>
  );
};

export default NewMember;
